module.exports = __webpack_public_path__ + "static/media/inv_top.1b8fa7ed.jpg";